import React, {
  RefObject,
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  useTableReset,
} from 'core/hooks';
import {
  VirtualTableInstance,
} from 'core/components/VirtualTable/types';
import Table from 'core/components/VirtualTable';
import {
  getRenderingProviders,
} from 'views/EMR/Settings/transport';
import Section from 'views/EMR/Settings/BillingConfigurations/Section';
import {
  commonTableClasses,
} from 'views/EMR/Settings/BillingConfigurations';
import {
  RenderingProviderDTO,
} from 'dtos/renderingProviderDTO';
import renderingProviderColumns from 'views/EMR/Settings/BillingConfigurations/RenderingProvider/columns';
import {
  settingsEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import RenderingProviderDialog, {
  RenderingProviderDialogProps,
} from 'views/EMR/Settings/BillingConfigurations/RenderingProvider/Dialog';
import isNil from 'lodash/isNil';
import useUserInfo from 'pages/Dashboard/hooks/useUserInfo';

export default function RenderingProvider() {
  const { tableInstanceRef } = useTableReset();
  const userInfo = useUserInfo();

  const [
    renderingProviderDialogParams,
    setRenderingProviderDialogParams,
  ] = useState<RenderingProviderDialogProps | null>(null);

  useEffect(() => {
    const refetch = () => {
      tableInstanceRef?.current?.refetch?.();
    };
    const unsubscribeFromRenderingProviderChange = settingsEventChannel.on('onRenderingProviderChange', refetch);
    const unsubscribeFromBillingProviderRuleChange = settingsEventChannel.on('onBillingProviderRuleChange', refetch);

    return () => {
      unsubscribeFromRenderingProviderChange();
      unsubscribeFromBillingProviderRuleChange();
    };
  }, []);

  const columns = useMemo(() => (
    userInfo?.flags?.mayEditOrgConfiguration
      ? renderingProviderColumns
      : renderingProviderColumns.slice(0, -1)
  ), [userInfo]);

  return (
    <Section header="Rendering Providers">
      <Table<RenderingProviderDTO>
        instanceRef={tableInstanceRef as RefObject<VirtualTableInstance>}
        getData={getRenderingProviders}
        getRowId={(row) => row?.renderingProviderId}
        columns={columns}
        emptySlot="No Rendering Providers Found"
        classes={commonTableClasses}
        dataKey="rendering-providers"
        onRowClick={(table, row) => {
          if (userInfo?.flags?.mayEditOrgConfiguration) {
            setRenderingProviderDialogParams({
              provider: row?.original,
            });
          }
        }}
      />
      {!isNil(renderingProviderDialogParams) && (
        <RenderingProviderDialog
          {...renderingProviderDialogParams}
          onClose={() => { setRenderingProviderDialogParams(null); }}
        />
      )}
    </Section>
  );
}
